/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PasswordRecoveryTokenResponseDto = {
    status: PasswordRecoveryTokenResponseDto.status;
    token: string;
    mail: string;
    name: string;
};

export namespace PasswordRecoveryTokenResponseDto {

    export enum status {
        VALID = 'valid',
        ALREADY_USED = 'already-used',
        NOT_VALID_ANYMORE = 'not-valid-anymore',
        NOT_FOUND = 'not-found',
    }


}

